import React, {Component} from "react";
import {List} from "immutable";
import {cx} from "../lib/ClassSet";
import "./InlineTable.css";

class InlineTable extends Component {


  constructor(props) {
    super(props);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  render() {

    let {data, fields, itemKey} = this.props;
    if (data == null) return null;

    let headerElements = fields.map((x, i) => {
      return <HeaderItem key={x.get("field", i)} data={x} />
    })

    let elements = data.map((x, i) => {
      return React.createElement(this.props.renderer, {key: x.get(itemKey, i), data: x, fields: fields, onClick: this.handleItemClick});
    })

    let classes = cx({
      "InlineTable": true,
      "u-hide-header": !this.props.showHeader,
      "s-inactive": !this.props.active
    })

    classes = `${classes} dt-${this.props.dataType}`;
    
    return (
      <div className={classes}>
        <table>
          <thead>
            <tr>
              {headerElements}
            </tr>
          </thead>
          <tbody>
            {elements}
          </tbody>
        </table> 
      </div>
    )
  }

  handleItemClick(e, data) {
    if (this.props.onItemClick) {
      this.props.onItemClick(data);
    }
  }

}


const HeaderItem = (props) => {
  const data = props.data;
  return (
    <td className={`f-${data.get("field")}`}>
      {data.get("title", data.get("field"))}
    </td>
  )
}

const Row = (props) => {

  const data = props.data;
  let elements = props.fields.map(x => {
    return <td key={x.get("field")} className={x.get("className")}>{data.get(x.get("field"))}</td>
  })

  return (
    <tr onClick={(e) => props.onClick(e, data)}>
      {elements}
    </tr>
  )

}

InlineTable.defaultProps = {
  renderer: Row,
  showHeader: true,
  data: List(),
  fields: List(),
  active: true,
  itemKey: "id",
  dataType: "default"
}

Row.defaultProps = {
  even: true
}

export default InlineTable;